<template>
  <section>
    <b-message
        type="is-info"
        :closable="false"
        aria-close-label="Close message"
        class="has-text-centered"
    >
      <p class="mb-3"><strong>The search results have expired. Refresh the results for up-to-date pricing and availability.</strong></p>
      <p>
        <b-button type="is-grey" outlined class="mr-1" @click="$emit('clearResults', type)">Start a New Search</b-button>
        <b-button type="is-info is-light" @click="$emit('refreshSearch', type)">Refresh Results</b-button>
      </p>
    </b-message>
  </section>

</template>

<script>
export default {
  name: "RefreshResults",
  props:{
    type:{
      type: String,
      default: '',
    }
  },
}
</script>

<style scoped>

</style>